import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useT } from "@/i18n/I18nContext";
import { syncNativeReminders, initNativeReminderTapListener } from "@/lib/nativeReminders";

/** Keeps native local-notification reminders in sync (native app only). */
export default function NativeReminderSync() {
  const { user } = useAuth();
  const { lang } = useT();
  const navigate = useNavigate();

  useEffect(() => { initNativeReminderTapListener(navigate); }, [navigate]);

  useEffect(() => {
    if (user?.role === "client") syncNativeReminders(lang);
  }, [user?.role, lang]);

  return null;
}
